import { useSiteTraits } from '@confluence/targeting/entry-points/useSiteTraits.ts';

export const HIGH_TOUCH_TWC_SIGNUP_TRAIT = 'is_high_touch_twc_signup';
export const LOW_TOUCH_TWC_SIGNUP_TRAIT = 'is_low_touch_twc_signup';

export type UseIsHighOrLowTouchTwcSignupResult = {
	isHighTouch: boolean | null;
	isLowTouch: boolean | null;
	loading: boolean;
	error: Error | null;
};

function parseBooleanTrait(value: unknown): boolean | null {
	if (value === undefined) {
		return null;
	}

	return value === true || value === 'true';
}

export function useIsHighOrLowTouchTwcSignup(): UseIsHighOrLowTouchTwcSignupResult {
	// Meeting-signal routing consumes the TAP context already bootstrapped by Confluence. It must
	// not introduce an ungated trait request of its own on every attach point.
	const { data, loading, error } = useSiteTraits({ skipBootstrap: true });
	let isHighTouch: boolean | null = null;
	let isLowTouch: boolean | null = null;

	for (const attribute of data?.attributes ?? []) {
		if (attribute.name === HIGH_TOUCH_TWC_SIGNUP_TRAIT) {
			isHighTouch = parseBooleanTrait(attribute.value);
		} else if (attribute.name === LOW_TOUCH_TWC_SIGNUP_TRAIT) {
			isLowTouch = parseBooleanTrait(attribute.value);
		}
	}

	return {
		isHighTouch,
		isLowTouch,
		loading,
		error,
	};
}
